"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inlineStaticStyles = exports.getVariantStyles = exports.baseStyles = exports.LinkButtonArrowWrapper = exports.LinkButton = exports.InlineButton = exports.FramedButton = exports.ButtonTitle = exports.ButtonIconWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const baseStyles = ({
  theme
}) => (0, _styledComponents.css)(["-webkit-appearance:none;position:relative;display:inline-flex;align-items:center;justify-content:center;outline:none;border:none;border-radius:0;font-family:", ";text-align:center;cursor:pointer;transition:background-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out;user-select:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], theme.buttons.fontFamily);
exports.baseStyles = baseStyles;
const ButtonTitle = exports.ButtonTitle = _styledComponents.default.span.withConfig({
  displayName: "button__ButtonTitle",
  componentId: "sc-12cf08m-0"
})(["white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
const ButtonIconWrapper = exports.ButtonIconWrapper = _styledComponents.default.span.withConfig({
  displayName: "button__ButtonIconWrapper",
  componentId: "sc-12cf08m-1"
})(["height:100%;display:flex;align-items:center;"]);
const inlineStaticStyles = exports.inlineStaticStyles = (0, _styledComponents.css)(["margin:", ";height:", ";width:", ";min-width:", ";font-size:", ";font-weight:", ";padding:", ";border-radius:", ";text-transform:", ";letter-spacing:", ";line-height:", ";", " ", " ", "{", " ", " &:first-letter{text-transform:", ";}}"], ({
  theme
}) => theme.buttons.inline.margin, ({
  theme
}) => theme.buttons.inline.height, ({
  theme
}) => theme.buttons.inline.width, ({
  theme,
  title
}) => title ? theme.buttons.inline.minWidth : theme.buttons.inline.minWidthIconOnly, ({
  theme
}) => theme.buttons.inline.fontSize, ({
  theme
}) => theme.buttons.inline.fontWeight, ({
  theme
}) => theme.buttons.inline.padding, ({
  theme
}) => theme.buttons.inline.borderRadius, ({
  theme
}) => theme.buttons.inline.textTransform, ({
  theme
}) => theme.buttons.inline.letterSpacing, ({
  theme
}) => theme.buttons.inline.lineHeight, ({
  startIcon
}) => startIcon && (0, _styledComponents.css)(["padding-left:", ";"], ({
  theme
}) => theme.buttons.inline.iconPadding), ({
  endIcon
}) => endIcon && (0, _styledComponents.css)(["padding-right:", ";"], ({
  theme
}) => theme.buttons.inline.iconPadding), ButtonTitle, ({
  startIcon
}) => startIcon && (0, _styledComponents.css)(["margin-left:8px;"]), ({
  endIcon
}) => endIcon && (0, _styledComponents.css)(["margin-right:8px;"]), ({
  theme
}) => theme.buttons.inline.textTransformFirstLetter);
const getVariantStyles = ({
  variant,
  backgroundColorMode,
  theme
}) => {
  var _theme$colors$button;
  let defaultPalette = theme.colors.button.secondary;
  let palette = ((_theme$colors$button = theme.colors.button) === null || _theme$colors$button === void 0 ? void 0 : _theme$colors$button[variant]) ?? defaultPalette;
  if (backgroundColorMode === _constants.BACKGROUND_COLOR_MODES.DARK) {
    defaultPalette = defaultPalette.dark;
    palette = palette.dark;
  }
  return (0, _styledComponents.css)(["color:", ";background-color:", ";border:", ";", "{svg{fill:", ";}}&:hover{background-color:", ";border:", ";}&:active{background-color:", ";border:", ";}&[disabled]:hover,&[disabled]{border:", ";color:", ";background-color:", ";pointer-events:none;", "{svg{fill:", ";}}}"], palette.textColor, palette.bgColor, palette.border || 'none', ButtonIconWrapper, palette.textColor, palette.hoverBgColor, palette.hoverBorder || palette.border || 'none', palette.activeBgColor, palette.activeBorder || palette.border || 'none', palette.disabledBorder || 'none', palette.disabledTextColor || defaultPalette.disabledTextColor, palette.disabledBgColor || defaultPalette.disabledBgColor, ButtonIconWrapper, palette.disabledTextColor || defaultPalette.disabledTextColor);
};
exports.getVariantStyles = getVariantStyles;
const FramedButton = exports.FramedButton = _styledComponents.default.button.withConfig({
  displayName: "button__FramedButton",
  componentId: "sc-12cf08m-2"
})(["", " height:", ";width:", ";min-width:", ";padding:", ";font-size:", ";font-weight:", ";text-transform:", ";letter-spacing:", ";line-height:", ";", " ", "{", " ", " &:first-letter{text-transform:", ";}}"], baseStyles, ({
  theme
}) => theme.buttons.default.height, ({
  theme
}) => theme.buttons.default.width, ({
  theme,
  title
}) => title ? theme.buttons.default.minWidth : theme.buttons.default.minWidthIconOnly, ({
  theme
}) => theme.buttons.default.padding, ({
  theme
}) => theme.buttons.default.fontSize, ({
  theme
}) => theme.buttons.default.fontWeight, ({
  theme
}) => theme.buttons.default.textTransform, ({
  theme
}) => theme.buttons.default.letterSpacing, ({
  theme
}) => theme.buttons.default.lineHeight, getVariantStyles, ButtonTitle, ({
  startIcon
}) => startIcon && (0, _styledComponents.css)(["margin-left:8px;"]), ({
  endIcon
}) => endIcon && (0, _styledComponents.css)(["margin-right:8px;"]), ({
  theme
}) => theme.buttons.default.textTransformFirstLetter);
const InlineButton = exports.InlineButton = _styledComponents.default.button.withConfig({
  displayName: "button__InlineButton",
  componentId: "sc-12cf08m-3"
})(["", " ", " ", " &:active{box-shadow:", ";}"], baseStyles, inlineStaticStyles, getVariantStyles, ({
  theme
}) => theme.buttons.inline.boxShadow);
const LinkButtonArrowWrapper = exports.LinkButtonArrowWrapper = _styledComponents.default.div.withConfig({
  displayName: "button__LinkButtonArrowWrapper",
  componentId: "sc-12cf08m-4"
})(["display:inline-flex;align-items:center;margin-left:12px;margin-right:12px;transition:margin 0.4s ease 0s;"]);
const LinkButton = exports.LinkButton = _styledComponents.default.span.withConfig({
  displayName: "button__LinkButton",
  componentId: "sc-12cf08m-5"
})(["cursor:pointer;display:inline-flex;font-family:", ";font-size:", ";font-weight:", ";text-transform:", ";letter-spacing:", ";word-break:break-word;", ""], ({
  theme
}) => theme.buttons.fontFamily, ({
  theme
}) => theme.buttons.link.fontSize, ({
  theme
}) => theme.buttons.link.fontWeight, ({
  theme
}) => theme.buttons.link.textTransform, ({
  theme
}) => theme.buttons.link.letterSpacing, ({
  variant,
  backgroundColorMode,
  theme
}) => {
  var _theme$colors$button2;
  let defaultPalette = theme.colors.button.secondary;
  let palette = ((_theme$colors$button2 = theme.colors.button) === null || _theme$colors$button2 === void 0 ? void 0 : _theme$colors$button2[variant]) ?? defaultPalette;
  if (backgroundColorMode === _constants.BACKGROUND_COLOR_MODES.DARK) {
    defaultPalette = defaultPalette.dark;
    palette = palette.dark;
  }
  return (0, _styledComponents.css)(["color:", ";", "{svg{color:", ";fill:", ";}}&:hover{color:", ";", "{margin-left:24px;margin-right:0px;transition:margin 0.4s ease 0s;svg{color:", ";fill:", ";}}}&:active{color:", ";}&[disabled]{color:", ";pointer-events:none;}"], palette.linkColor || palette.bgColor, LinkButtonArrowWrapper, palette.linkArrowColor, palette.linkArrowColor, palette.linkHoverColor || palette.linkColor, LinkButtonArrowWrapper, palette.linkArrowColor, palette.linkArrowColor, palette.linkActiveColor || palette.linkColor || palette.activeBgColor, theme.colors.button.disabledTextColor || theme.colors.button.disabledBgColor);
});